import { useQueryClient } from '@tanstack/react-query';
import type { QueryKey } from '@tanstack/react-query';
import { useCallback, useRef, useEffect } from 'react';

import { useSubscribeWebsocket } from 'utils/hooks';

export type PaneWebSocketParam = {
  topic: string[] | null;
  queryKeyOrInvalidator: QueryKey | (() => unknown);
  unsubscribeDebounceTime?: number;
};

export const usePaneWebSocket = ({
  topic,
  queryKeyOrInvalidator,
  unsubscribeDebounceTime = 0,
}: PaneWebSocketParam) => {
  const queryClient = useQueryClient();
  const invalidationRef = useRef(queryKeyOrInvalidator);
  useEffect(() => {
    invalidationRef.current = queryKeyOrInvalidator;
  }, [queryKeyOrInvalidator]);

  const callback = useCallback(
    (/* message: JsonValue */) => {
      const current = invalidationRef.current;
      if (typeof current === 'function') {
        current();
      } else {
        queryClient.invalidateQueries({ queryKey: current });
      }
    },
    [queryClient],
  );

  useSubscribeWebsocket(topic, callback, unsubscribeDebounceTime);
};
